import { FEEDBACK_TARGET_KIND, assertNever, type Target } from './types';

/** Maps each target kind to its current draft feedback tag taxonomy. */
const TAGS_BY_TARGET_KIND = {
  general: ['bug', 'confusing', 'missing_feature', 'performance', 'praise'],
  [FEEDBACK_TARGET_KIND.DOC]: ['inaccurate', 'incomplete', 'outdated', 'off_topic', 'well_done'],
  [FEEDBACK_TARGET_KIND.FEED_ITEM]: ['not_relevant', 'duplicate', 'low_quality', 'interesting'],
  [FEEDBACK_TARGET_KIND.PRODUCT]: [
    'wrong_details',
    'price_issue',
    'availability',
    'not_what_i_wanted',
    'good_match',
  ],
  [FEEDBACK_TARGET_KIND.TOPIC]: ['unclear', 'incomplete', 'inaccurate', 'helpful'],
} as const satisfies Record<
  'general' | (typeof FEEDBACK_TARGET_KIND)[keyof typeof FEEDBACK_TARGET_KIND],
  readonly string[]
>;

/** Returns the feedback tags offered for the given target, or general tags for null targets. */
export function tagsForTarget(target: Target): string[] {
  if (target === null) {
    return [...TAGS_BY_TARGET_KIND.general];
  }

  switch (target.kind) {
    case FEEDBACK_TARGET_KIND.DOC:
      return [...TAGS_BY_TARGET_KIND.doc];
    case FEEDBACK_TARGET_KIND.FEED_ITEM:
      return [...TAGS_BY_TARGET_KIND.feed_item];
    case FEEDBACK_TARGET_KIND.PRODUCT:
      return [...TAGS_BY_TARGET_KIND.product];
    case FEEDBACK_TARGET_KIND.TOPIC:
      return [...TAGS_BY_TARGET_KIND.topic];
    default:
      return assertNever(target);
  }
}
